import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import NavBar from "@/components/NavBar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import MenuSection from "@/components/MenuSection";
import WagonSection from "@/components/WagonSection";
import Configurator from "@/components/Configurator";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";

export default function HomePage() {
    const lenisRef = useRef(null);
    const [menuId, setMenuId] = useState(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        lenisRef.current = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    // Support deep links like /#menuer (used by NavBar/Footer on city pages).
    useEffect(() => {
        const hash = window.location.hash;
        if (!hash) return;
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        requestAnimationFrame(() => {
            lenisRef.current?.scrollTo(el, { offset: -72, duration: 0 });
        });
    }, []);

    const scrollTo = (id) => {
        if (id === "top") {
            lenisRef.current?.scrollTo(0, { duration: 1.2 });
        } else {
            lenisRef.current?.scrollTo(`#${id}`, { offset: -72, duration: 1.2 });
        }
    };

    const selectMenu = (id) => {
        setMenuId(id);
        scrollTo("byg-din-event");
    };

    return (
        <div className="min-h-screen bg-background font-sans text-foreground antialiased">
            <Seo
                title="Lej En Pølsevogn.dk — Lej en pølsevogn til din fest"
                siteName="Lej En Pølsevogn.dk"
                description="Lej en ægte dansk pølsevogn til bryllup, fødselsdag eller firmafest. Mere end 25 års erfaring — vi kører i hele Danmark. Send en 100% uforpligtende forespørgsel."
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: "Lej En Pølsevogn.dk",
                    description: "Udlejning af danske pølsevogne til fester og events.",
                    telephone: "+4521829346",
                    email: "dlmpjb@gmail.com",
                    url: typeof window !== "undefined" ? window.location.origin : undefined,
                }}
            />
            <NavBar onNavigate={scrollTo} />
            <main>
                <Hero onCta={() => scrollTo("byg-din-event")} onMenu={() => scrollTo("menuer")} />
                <div className="checker -mx-2 -mt-[1vw] -rotate-1 h-3" aria-hidden="true" />
                <Marquee />
                <MenuSection selectedMenu={menuId} onSelectMenu={selectMenu} />
                <Marquee rotate="rotate-1" reverse />
                <Configurator menuId={menuId} onMenuChange={setMenuId} />
                <WagonSection />
                <FaqSection />
            </main>
            <Footer onNavigate={scrollTo} />
            <Toaster position="bottom-center" richColors />
        </div>
    );
}
